package abilities

import component.*
import org.jbox2d.dynamics.*
import utils.*

class FireBolt {

    var isTouched = false
        private set

    private val targets = mutableSetOf<PlayerPhysicState>()

    fun getTargets(): Set<PlayerPhysicState> = targets

    fun addTarget(player: PlayerPhysicState) {
        println("player added")
        targets.add(player)
    }

    fun removePlayer(player: PlayerPhysicState) {
        println("player removed")
        targets.remove(player)
    }

    fun hit() {
        isTouched = true
    }
}
